import React          from 'react';
import styled         from 'styled-components';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText as MuiDialogContentText,
  DialogActions as MuiDialogActions,
}                     from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Progress }   from '@components/Progress/Progress';

interface IAdDeleteConfirmDialog {
  width        : string;
  classes      : any;
  onCancel     : () => void;
  onConfirm    : () => Promise<void>;
  isOpen       : boolean;
  isAdRemoving : boolean;
}

const DialogContentText = styled(MuiDialogContentText)`
  && {
    text-align : center;
    font-size  : 18px;
    color      : ${({ theme: { textColor } }): string => textColor.secondary};
  }
` as any;

const DialogActions = styled(MuiDialogActions)`
  && {
    justify-content: center;

    ${({ theme: { width } }: any): false | string => (width === 'xs' && 'flex-direction: column')};
  }
` as any;

const CancelButton = styled(Button)`
  && {
    min-width : 140px;
    margin    : auto 10px;
    ${({ theme: { width } }: any): any => (width === 'xs' && 'margin-bottom: 20px')};
  }
` as any;

const DeleteButton = styled(Button)`
  && {
    min-width        : 140px;
    margin           : auto 10px;
    color            : ${({ theme: { textColor } }): string => textColor.white};
    background-color : ${({ theme: { textColor } }): string => textColor.red};

    :hover {
      background-color: ${({ theme: { textColor } }): string => textColor.red};
    }

    :disabled {
      background-color: ${({ theme: { backgroundColor } }): string => backgroundColor.gray};
    }
  }
` as any;

const styles = {
  paper: {
    borderRadius : 5,
    padding      : 30,
  },
};

export const AdDeleteConfirmDialogComponent = ({
  width,
  classes,
  isOpen,
  isAdRemoving,
  onCancel,
  onConfirm,
}: IAdDeleteConfirmDialog): JSX.Element => (
  <Dialog
    aria-labelledby = "confirm-delete-ad-dialog"
    open            = {isOpen}
    classes         = {{ paper: classes.paper }}
  >
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete this ad?
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <CancelButton
        color     = "secondary"
        variant   = "outlined"
        fullWidth = {width === 'xs'}
        onClick   = {onCancel}
      >
        Cancel
      </CancelButton>

      <DeleteButton
        variant   = "contained"
        fullWidth = {width === 'xs'}
        onClick   = {onConfirm}
        disabled  = {isAdRemoving}
      >
        Yes, Delete
        <Progress loading={isAdRemoving} />
      </DeleteButton>
    </DialogActions>
  </Dialog>
);

export const AdDeleteConfirmDialog = withStyles(styles)(AdDeleteConfirmDialogComponent);
